import { arrayUniqueByKey } from "./general"

export function generateEversetCartURL(items) {
  const uniqueItems = arrayUniqueByKey(items, 'variant_id')
  const ensuredWithVariantId = uniqueItems.filter((item) => !!item.variant_id)
  return `https://theeverset.com/cart#${btoa(
    JSON.stringify(ensuredWithVariantId.map(({ variant_id, quantity }) => ({ id: variant_id, quantity }))),
  )}`
}

export function validateEversetCardLink(items) {
  const uniqueItems = arrayUniqueByKey(items, 'variant_id')
  const ensuredWithVariantId = uniqueItems.filter((item) => !!item.variant_id)
  if (ensuredWithVariantId.length !== uniqueItems.length) {
    console.warn('Detected Everset checkout link contained items with empty variant_id, link will be cut.')
  }
}
